import { commonAxios, clientAxios } from '@/plugins/axios'
const baseClientUrl = '/v1/customer'

export const getListAddress = () => commonAxios.get('/v1/common/address')
export const setDefaultAddress = (customer_id, address_id, body) =>
  clientAxios.put(`${baseClientUrl}/${customer_id}/delivery-address/${address_id}/update`, body)
export const getAddressDetail = (customer_address_id) =>
  commonAxios.get(`/v1/common/address/detail/${customer_address_id}`)
export const updateAddress = (customer_id, address_id, body) =>
  clientAxios.put(`${baseClientUrl}/${customer_id}/delivery-address/${address_id}/update`, body)
export const newAddress = (body) => commonAxios.post('/v1/common/address/new', body)
export const deleleAddress = (address_id) => commonAxios.delete(`/v1/common/address/delete/${address_id}`)
